import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
  $getNodeByKey,
} from 'lexical';

import { $createVariableNode, $isVariableNode } from './VariableNode';

export type InsertVariablePayload = {
  variable: string;
};

export type UpdateVariablePayload = {
  variable: string;
  nodeId: string;
};

export const INSERT_VARIABLE: LexicalCommand<InsertVariablePayload> = createCommand();
export const UPDATE_VARIABLE: LexicalCommand<UpdateVariablePayload> = createCommand();

export const VariablePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<InsertVariablePayload>(
        INSERT_VARIABLE,
        ({ variable }) => {
          editor.update(() => {
            const selection = $getSelection();

            if (!$isRangeSelection(selection)) {
              return false;
            }

            const variableNode = $createVariableNode(variable);
            selection.insertNodes([variableNode]);

            return true;
          });

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand<UpdateVariablePayload>(
        UPDATE_VARIABLE,
        ({ variable, nodeId }) => {
          editor.update(() => {
            const node = $getNodeByKey(nodeId);
            if ($isVariableNode(node)) {
              node.setVariable(variable);
            }

            return true;
          });

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor]);

  return null;
};
